import React from "react"
import Button from "../Button/Button"
import {Application} from "../../resources/application"
import {useOrgSettings} from "../../services/orgAuth"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {HasPermission} from "../../containers/PermissionedUser/Permission"
import {useIsAllowResubmit} from "../../services/permission"

interface ReevaluateButtonProps {
	canReevaluate: boolean
	application: Application
	buttonOnClick: () => void
}

interface ActionButtonProps {
	label: string
	canReevaluate: boolean
	buttonOnClick: () => void
}

const ActionButton = ({label, canReevaluate, buttonOnClick}: ActionButtonProps) => {
	return (
		<Button
			tooltipPlace="bottom"
			disabled={!canReevaluate}
			theme="neutral"
			variant="outline"
			onClick={buttonOnClick}
			prefixIcon="pencil-1--interface-essential"
			className="mr-2"
		>
			<span>{label}</span>
		</Button>
	)
}

const ReevaluateButton = ({canReevaluate, application, buttonOnClick}: ReevaluateButtonProps) => {
	const orgSettingsAsyncResult = useOrgSettings(application.relationships.org.data.id)
	return (
		<HasPermission resource="orgSettings" action="get">
			<AsyncResultComponent asyncResult={orgSettingsAsyncResult} pendingComponent={<></>}>
				{({value: orgSettings}) => {
					const canShowButton = useIsAllowResubmit(
						orgSettings.attributes.generalSettings.enableReevaluateApplication,
						application.relationships.org.data.id,
						application.attributes.assignee
					)

					return canShowButton ? (
						<ActionButton label="Edit and Re-submit" canReevaluate={canReevaluate} buttonOnClick={buttonOnClick} />
					) : (
						<React.Fragment />
					)
				}}
			</AsyncResultComponent>
		</HasPermission>
	)
}

export default ReevaluateButton
